import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import './styles/App.css';
import AppBootStatus from './components/AppBootStatus';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes/AppRoutes';

const App = () => (
  <AuthProvider>
    <ThemeProvider>
      <Router>
        <div className="app">
          <main className="app__main">
            <AppBootStatus>
              <AppRoutes />
            </AppBootStatus>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  </AuthProvider>
);

export default App;
